// extracted by mini-css-extract-plugin
export default {"loginRedirect":"loginRedirect-rYOlI","header":"header-BqMLQ","body":"body-Yjf2u","text":"text-eyBdP","button":"button-CLnPv"};